import { ENV } from '@config/env';
import { FEATURES } from '@config/features';

// URLs come from /runtime-config.js, written at container start (or from .env
// under the Vite dev server), so there is no per-environment picking left here.
export const SERVER_BASE_URL = ENV.siteUrl;
export const API_BASE_URL = ENV.apiBaseUrl;
export const SOCKET_URL = ENV.socketUrl;

// A value that never reached the container looks exactly like a broken backend
// from the browser: no request, no error, nothing in the console. This mirrors
// what this page actually received.
export const RUNTIME_CONFIG = Object.freeze({
  env: ENV.name,
  mode: ENV.mode,
  apiBaseUrl: API_BASE_URL || null,
  socketUrl: SOCKET_URL || null,
  features: FEATURES,
});

/**
 * Called once at boot (main.jsx). Also parked on `window.__appConfig` so the
 * same values can be re-read at any point in a session without a reload.
 */
export function logRuntimeConfig() {
  if (typeof window !== 'undefined') {
    window.__appConfig = RUNTIME_CONFIG;
  }

  // console.warn, not log: the eslint config allows warn/error only.
  console.warn('[config] runtime config', RUNTIME_CONFIG);
}
